import { css } from '@emotion/react';

export const containerStyle = (background: string) => css`
  position: relative;
  max-width: 340px;
  border-radius: 8px;
  background-color: ${background};
  padding: 16px;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.12);
`;

export const headerRowStyle = css`
  display: flex;
  align-items: flex-start;
  gap: 12px;
`;

export const iconCircleStyle = (iconBackground: string) => css`
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background-color: ${iconBackground};
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const errorOutlineIconStyle = (iconColor: string) => css`
  font-size: 18px;
  color: ${iconColor};
`;

export const titleStyle = css`
  flex: 1;
  font-size: 14px;
  font-weight: 600;
  color: #2d2d2d;
  line-height: 1.4;
`;

export const closeButtonStyle = css`
  flex-shrink: 0;
  padding: 2px;
  margin-top: -2px;
  color: #8484a8;
`;

export const closeIconStyle = css`
  font-size: 18px;
`;

export const bodyTextStyle = css`
  margin-top: 12px;
  font-size: 12px;
  color: #7a7a7a;
  line-height: 1.5;
`;

export const linkStyle = (linkColor: string) => css`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin-top: 12px;
  font-size: 14px;
  font-weight: 600;
  color: ${linkColor};
  text-decoration: none;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;

export const warningLinkStyle = (linkColor: string) => css`
  ${linkStyle(linkColor)};
  background: none;
  border: none;
  padding: 0;
`;
